// Labels new to the "My contributions" page. Shared ones (title, empty state,
// audio errors, pagination) stay in translations.ts under myContributionsPage.
export const myContributionsCopy = {
  fr: {
    description: "Vos envois, leur vérification et l'historique de tout ce que vous avez fait.",
    loadError: "Impossible de charger vos contributions.",
    retry: "Réessayer",
    figContributions: "Contributions",
    figAccepted: "Audios validés",
    figPending: "En attente",
    figPendingHint: "Audios en cours de vérification",
    figRejected: "Audios rejetés",
    figTranscriptions: "Transcriptions",
    figReviews: "Vérifications faites",
    earningsText: "Seuil, test de qualification et paiements : tout se suit dans Mes gains.",
    languagesTitle: "Par langue",
    colLanguage: "Langue",
    colSent: "Audios envoyés",
    colAccepted: "Validés",
    colRejected: "Rejetés",
    colRate: "Taux de validation",
    unknownLanguage: "Langue non précisée",
    rateValue: "{rate} % validés dans cette langue",
    flowTitle: "Audios validés par mois",
    flowTotal: "{count} sur 6 mois",
    flowBar: "{month} : {accepted} validés, {rejected} rejetés, {pending} en attente",
    historyTitle: "Historique",
    historyCount: "{count} contributions",
    filtersLabel: "Filtrer l'historique",
    statusAll: "Toutes",
    statusValidated: "Validées",
    statusPending: "En attente",
    statusRejected: "Rejetées",
    language: "Langue",
    allLanguages: "Toutes les langues",
    from: "Du",
    to: "Au",
    clearFilters: "Effacer les filtres",
    noMatchTitle: "Aucune contribution ne correspond à ces filtres",
    noMatchHint: "Élargissez la période ou choisissez une autre langue.",
    colDate: "Date",
    colType: "Type",
    colStatus: "Statut",
    noDate: "Date inconnue",
    kindAudio: "Audio",
    kindText: "Texte",
    kindPhraseRecording: "Phrase lue",
    kindPhraseCreated: "Traduction",
    kindOther: "Contribution",
    badgeValidated: "Validée",
    badgePending: "En attente",
    badgeRejected: "Rejetée",
    previous: "Page précédente",
    next: "Page suivante",
  },
  en: {
    description: "What you sent, how it was reviewed, and the history of everything you did.",
    loadError: "Your contributions could not be loaded.",
    retry: "Retry",
    figContributions: "Contributions",
    figAccepted: "Validated audio",
    figPending: "Pending",
    figPendingHint: "Audio being reviewed",
    figRejected: "Rejected audio",
    figTranscriptions: "Transcriptions",
    figReviews: "Reviews done",
    earningsText: "Threshold, qualification test and payouts: follow them all in My earnings.",
    languagesTitle: "By language",
    colLanguage: "Language",
    colSent: "Audio sent",
    colAccepted: "Validated",
    colRejected: "Rejected",
    colRate: "Validation rate",
    unknownLanguage: "Language not set",
    rateValue: "{rate}% validated in this language",
    flowTitle: "Validated audio per month",
    flowTotal: "{count} over 6 months",
    flowBar: "{month}: {accepted} validated, {rejected} rejected, {pending} pending",
    historyTitle: "History",
    historyCount: "{count} contributions",
    filtersLabel: "Filter the history",
    statusAll: "All",
    statusValidated: "Validated",
    statusPending: "Pending",
    statusRejected: "Rejected",
    language: "Language",
    allLanguages: "All languages",
    from: "From",
    to: "To",
    clearFilters: "Clear filters",
    noMatchTitle: "No contribution matches these filters",
    noMatchHint: "Widen the period or pick another language.",
    colDate: "Date",
    colType: "Type",
    colStatus: "Status",
    noDate: "Unknown date",
    kindAudio: "Audio",
    kindText: "Text",
    kindPhraseRecording: "Phrase read",
    kindPhraseCreated: "Translation",
    kindOther: "Contribution",
    badgeValidated: "Validated",
    badgePending: "Pending",
    badgeRejected: "Rejected",
    previous: "Previous page",
    next: "Next page",
  },
} as const;

export type MyContributionsCopy = (typeof myContributionsCopy)[keyof typeof myContributionsCopy];

export const fill = (text: string, values: Record<string, string | number>) =>
  Object.entries(values).reduce((out, [key, value]) => out.split(`{${key}}`).join(String(value)), text);
